import { FileFillerInterface } from '../../interfaces/file-filler.interface';
import { CalculationResponse } from '../../responses/calculation.response';
import { PdfFillerFactory } from './pdf-filler.factory';
import { ExportTypeEnum } from '../../enums/export-type.enum';
import { XlsxFillerFactory } from './xlsx-filler.factory';

export class FileFillerFactory {
  constructor(
    private readonly pdfFillerFactory: PdfFillerFactory,
    private readonly xlsxFillerFactory: XlsxFillerFactory,
  ) {
  }

  getFileFiler(exportType: ExportTypeEnum, calculation: CalculationResponse): FileFillerInterface {
    switch (exportType) {
      case ExportTypeEnum.PDF: {
        return this.pdfFillerFactory.getPdfFiller(calculation);
      }
      case ExportTypeEnum.XLSX: {
        return this.xlsxFillerFactory.getXlsxFiller(calculation);
      }
      default:
        throw new Error(`Export type ${exportType} is not supported`);
    }
  }
}
